// index.ts
import { isNamedPitch } from "@tonaljs/pitch";
export * from "@tonaljs/pitch";
export * from "@tonaljs/pitch-distance";
export * from "@tonaljs/pitch-interval";
export * from "@tonaljs/pitch-note";
var fillStr = (s, n) => Array(Math.abs(n) + 1).join(s);
function deprecate(original, alternative, fn) {
  return function(...args) {
    console.warn(`${original} is deprecated. Use ${alternative}.`);
    return fn.apply(this, args);
  };
}
var isNamed = deprecate("isNamed", "isNamedPitch", isNamedPitch);
export {
  deprecate,
  fillStr,
  isNamed
};
//# sourceMappingURL=index.mjs.map